import {useCallback} from 'react';

import {CaptchaTokenPayload} from '../types';
import {VkCaptchaTokenPayload} from '../types.internal';
import {
  createErrorMessageForAnalytics,
  useLogVkCaptchaEvents,
} from './hooks/useLogVkCaptchaEvents';

type Result =
  | {
      error?: false;
    }
  | {
      error: true;
      errorDetail: unknown;
    };

export const useLogCaptchaValidationResult = () => {
  const {logValidationResult} = useLogVkCaptchaEvents();

  return useCallback(
    (captchaToken: CaptchaTokenPayload | null, result: Result) => {
      if (!captchaToken || captchaToken.provider !== 'vk') {
        return;
      }
      const placement = (captchaToken as VkCaptchaTokenPayload).source;
      if (result.error) {
        logValidationResult({
          placement,
          error: result.error,
          errorMessage: createErrorMessageForAnalytics(result.errorDetail),
        });
      } else {
        logValidationResult({placement, error: false});
      }
    },
    [logValidationResult],
  );
};
